import { number } from "prop-types";
import { CircularProgress } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";

export const CenteredCircularProgress = ({ size=40 }) => {
  const classes = useStyle({ size });

  return <CircularProgress size={size} className={classes.root} />;
};

CenteredCircularProgress.propTypes = {
  size: number,
}

const useStyle = makeStyles(() => ({
  root: {
    position: "absolute",
    top: "50%",
    left: "50%",
    marginLeft: ({ size }) => -(size/2),
    marginTop: ({ size }) => -(size/2),
  },
}));